import { render, staticRenderFns } from "./SurveyConfirmation.vue?vue&type=template&id=2c145115&"
import script from "./SurveyConfirmation.vue?vue&type=script&lang=js&"
export * from "./SurveyConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports